<template>
    <h1>Hello World!</h1>
</template>

<script>
export default {
  name: 'Secret'
}
</script>

<style scoped>

</style>
